// src/utils/colorSchemes.js
export const getColorScheme = (accentColor = 'maroon', theme = 'light') => {
  const schemes = {
    maroon: {
      light: {
        primary: '#8B2342',
        secondary: '#B85A4C',
        accent: '#D2691E',
        background: '#F9F5F0', // Always cream background
        cardBg: '#E0CDD6', // Strong maroon-tinted card
        lightBg: 'rgba(139, 35, 66, 0.6)', // Same color for consistency
        headerBg: '#5D3D92',
        headerBgDark: '#42296B',
        hoverBg: '#513582',
        hoverBgDark: '#382359',
        navActive: '#76263c',
        navHover: '#a54551'
      },
      dark: {
        primary: '#8B2342',
        secondary: '#B85A4C',
        accent: '#D2691E',
        background: '#1a1a1a', // Dark charcoal instead of maroon
        cardBg: 'rgba(255, 255, 255, 0.95)', // Keep cards light/white
        lightBg: 'rgba(255, 255, 255, 0.2)',
        headerBg: '#5D3D92',
        headerBgDark: '#42296B',
        hoverBg: '#513582',
        hoverBgDark: '#382359',
        navActive: '#76263c',
        navHover: '#a54551'
      }
    },
    teal: {
      light: {
        primary: '#057A8A',
        secondary: '#06A4B8',
        accent: '#09C9D1',
        background: '#F9F5F0', // Always cream background  
        cardBg: '#B8DDE2', // Strong teal-tinted card
        lightBg: 'rgba(255, 255, 255, 0.2)',
        headerBg: '#0891B2',
        headerBgDark: '#0E7490',
        hoverBg: '#0891B2',
        hoverBgDark: '#0E7490',
        navActive: '#0891B2',
        navHover: '#06B6D4'
      },
      dark: {
        primary: '#057A8A',
        secondary: '#06A4B8',
        accent: '#09C9D1',
        background: '#1a1a1a', // Same dark charcoal
        cardBg: 'rgba(255, 255, 255, 0.95)', // Keep cards light/white
        lightBg: 'rgba(255, 255, 255, 0.2)',
        headerBg: '#0891B2',
        headerBgDark: '#0E7490',
        hoverBg: '#0891B2',
        hoverBgDark: '#0E7490',
        navActive: '#0891B2',
        navHover: '#06B6D4'
      }
    },
    indigo: {
      light: {
        primary: '#4338CA',
        secondary: '#6366F1',
        accent: '#818CF8',
        background: '#F9F5F0', // Always cream background
        cardBg: '#C8C2FF', // Strong indigo-tinted card
        lightBg: 'rgba(67, 56, 202, 0.6)', // Same color for consistency
        headerBg: '#4338CA',
        headerBgDark: '#3730A3',
        hoverBg: '#4338CA',
        hoverBgDark: '#3730A3',
        navActive: '#4338CA',
        navHover: '#6366F1'
      },
      dark: {
        primary: '#4338CA',
        secondary: '#6366F1',
        accent: '#818CF8',
        background: '#1a1a1a', // Same dark charcoal
        cardBg: 'rgba(255, 255, 255, 0.95)', // Keep cards light/white
        lightBg: 'rgba(255, 255, 255, 0.2)',
        headerBg: '#4338CA',
        headerBgDark: '#3730A3',
        hoverBg: '#4338CA',
        hoverBgDark: '#3730A3',
        navActive: '#4338CA',
        navHover: '#6366F1'
      }
    },
    emerald: {
      light: {
        primary: '#047857',
        secondary: '#10B981',
        accent: '#34D399',
        background: '#F9F5F0', // Always cream background
        cardBg: '#D5F1DC', // Strong emerald-tinted card
        lightBg: 'rgba(255, 255, 255, 0.2)',
        headerBg: '#047857',
        headerBgDark: '#065F46',
        hoverBg: '#047857',
        hoverBgDark: '#065F46',
        navActive: '#047857',
        navHover: '#10B981'
      },
      dark: {
        primary: '#047857',
        secondary: '#10B981',
        accent: '#34D399',
        background: '#1a1a1a', // Same dark charcoal
        cardBg: 'rgba(255, 255, 255, 0.95)', // Keep cards light/white
        lightBg: 'rgba(255, 255, 255, 0.2)',
        headerBg: '#047857',
        headerBgDark: '#065F46',
        hoverBg: '#047857',
        hoverBgDark: '#065F46',
        navActive: '#047857',
        navHover: '#10B981'
      }
    }
  };

  // Get the scheme for the selected accent color and theme
  const selectedScheme = schemes[accentColor] || schemes.maroon;
  return selectedScheme[theme] || selectedScheme.light;
};